import { REVENUE_TAB_TITLE } from "@/pages/Explorer/constants/explorer.constants";

export const localBreadCrumbDispatch = {
  RevenueExplorer: {
    path: "/explorer/commercial",
    label: REVENUE_TAB_TITLE,
    name: "RevenueExplorer",
  },
  ExploreAsset: {
    path: "/explorer/explore-asset",
    label: "Asset",
    name: "ExploreAsset",
  },
  TradeHub: {
    path: "/trading/trade-hub",
    label: "Optimiser Hub",
    name: "TradeHub",
  },
  //   TechnicalInsights: {
  //     path: "/portfolio/performance/technical",
  //     label: "Technical Insights",
  //     name: "TechnicalInsights",
  //   },
};

export const dispatchedFromComponent = {
  [localBreadCrumbDispatch.RevenueExplorer.name]:
    localBreadCrumbDispatch.RevenueExplorer.path,
  [localBreadCrumbDispatch.ExploreAsset.name]:
    localBreadCrumbDispatch.ExploreAsset.path,
  [localBreadCrumbDispatch.TradeHub.name]:
    localBreadCrumbDispatch.TradeHub.path,
  //   [localBreadCrumbDispatch.TechnicalInsights.name]:
  //     localBreadCrumbDispatch.TechnicalInsights.path,
};

/**
 * Adds spaces before capital letters in a component name
 * e.g., "RevenueExplorer" -> "Revenue Explorer"
 */
export const formatComponentName = (name: string): string => {
  return name.replace(/([A-Z])/g, " $1").trim();
};

export const shouldHandleOwnBreadcrumbs = (path: string) => {
  return Object.values(dispatchedFromComponent).some((dispatchedPath) =>
    path.startsWith(dispatchedPath)
  );
};
